<template>
  <div id="banner" :style="{ background: 'url(' + banner_bg + ') 100% 100%' }">
    <div id="banner-info">
      <div id="banner-logo">
        <img src="@/assets/imgs/m/mlogo.png" alt="洋宇集团" />
      </div>
      <div id="banner-text">引领时尚科技，成就不凡未来</div>
    </div>
  </div>
</template>
<script>
import bannerBg from "@/assets/imgs/m/b-bg.png";

export default {
  name: "banner",
  data() {
    return {
      banner_bg: bannerBg,
    };
  },
};
</script>
<style scoped>
#banner {
  width: 100vw;
  padding-top:.6rem;
  height: 1.68rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

#banner #banner-info {
  width: 2.02rem;
  height: 0.36rem;
}

#banner #banner-info #banner-logo,
#banner #banner-info #banner-logo img {
  width: 2.02rem;
  height: 0.18rem;
}

#banner #banner-info #banner-text {
    width:2.02rem;
    text-align: center;
  margin-top: 0.08rem;
  font-size: 0.11rem;
  font-weight: 400;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/m/Banner.vue